export default __webpack_public_path__ + "static/cruiselines-carnival-kids-1-9c83fe5ab8e0bbb859b17f5e6e4f645a.jpg";